import React from 'react';
import { ArrowLeftIcon } from 'lucide-react';
import { LanguageSwitcher } from '../components/LanguageSwitcher';
import { SEO } from '../components/SEO';
import { breadcrumbSchema } from '../utils/structuredData';
export function ImprintPage() {
  const structuredData = [breadcrumbSchema([{
    name: 'Home',
    url: 'https://close-crm-agentur.de'
  }, {
    name: 'Imprint',
    url: 'https://close-crm-agentur.de/en/imprint'
  }])];
  return <>
      <SEO title="Imprint" description="Legal notice and contact details for Close CRM Agentur." canonical="https://close-crm-agentur.de/en/imprint" noindex={true} structuredData={structuredData} data-id="element-520" data-mp="1pgkxy7blzzkr" />
      <div className="min-h-screen bg-[#0a0a0a]" data-id="element-521" data-mp="1fkrf667ar9uj">
        <header className="fixed top-0 left-0 right-0 z-50 bg-[#0a0a0a]/80 backdrop-blur-lg border-b border-white/5" data-id="element-522" data-mp="3ew0w6rnzw0vv">
          <nav className="max-w-7xl mx-auto px-3 sm:px-6 lg:px-8" data-id="element-523" data-mp="39xzeob67w9mi">
            <div className="flex items-center justify-between h-14 sm:h-16 lg:h-20 gap-2 sm:gap-4" data-id="element-524" data-mp="y8w13qo81o16">
              <a href="/" className="flex items-center gap-1.5 sm:gap-2 flex-shrink-0 sm:flex-1" aria-label="Close CRM Agentur homepage" data-id="element-525" data-mp="12bilx7mh68ov">
                <div className="w-7 h-7 sm:w-8 sm:h-8 rounded-lg bg-[#0ea5e9] flex items-center justify-center flex-shrink-0" data-id="element-526" data-mp="t9su40ool7qk">
                  <span className="text-white font-bold text-xs sm:text-sm" data-id="element-527" data-mp="1h17zk2br8561">
                    C
                  </span>
                </div>
                <span className="text-white font-bold text-sm sm:text-base lg:text-lg whitespace-nowrap" data-id="element-528" data-mp="17a3mj85n2udu">
                  Close CRM Agentur
                </span>
              </a>
              <LanguageSwitcher className="absolute right-3 sm:relative sm:right-0" data-id="element-529" data-mp="1c73q9cf0nl1s" />
              <a href="/" className="hidden sm:flex items-center justify-center gap-2 text-gray-400 hover:text-white transition-colors text-sm flex-shrink-0" data-id="element-530" data-mp="1zxg8bg3z6y63">
                <ArrowLeftIcon className="w-4 h-4" data-id="element-531" data-mp="2ejdmczycgtzx" />
                Back to homepage
              </a>
            </div>
          </nav>
        </header>

        <main className="pt-24 pb-16" data-id="element-532" data-mp="24miq6npjn5ot">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-533" data-mp="24lh29infiopo">
            <div className="prose prose-invert prose-lg max-w-none" data-id="element-534" data-mp="20kndyo62r7w9">
              <h1 className="text-4xl font-bold text-white mb-8" data-id="element-535" data-mp="1vmc4iejoyzek">Imprint</h1>
              <div className="space-y-8 text-gray-300" data-id="element-536" data-mp="1vof3vp6qi4vy">
                <section data-id="element-537" data-mp="1qv3t5cysx3yr">
                  <h2 className="text-2xl font-bold text-white mb-4" data-id="element-538" data-mp="1qukjejjb1lvt">
                    Company address
                  </h2>
                  <p className="leading-relaxed" data-id="element-539" data-mp="1gxpm23yrprj4">
                    CRM Kraft LLC
                    <br data-id="element-540" data-mp="1gvv48yismfj9" />
                    Represented by: Justus Kraft
                    <br data-id="element-541" data-mp="1cvb6bsqeb7w2" />
                    7901 4th St. N, Ste. 300
                    <br data-id="element-542" data-mp="17y2lfkdv4pr4" />
                    St. Petersburg, FL 33702
                    <br data-id="element-543" data-mp="3jkmwo9eawej5" />
                    United States of America
                  </p>
                </section>

                <section data-id="element-544" data-mp="3oiohozvaenx9">
                  <h2 className="text-2xl font-bold text-white mb-4" data-id="element-545" data-mp="3ohwjdhab2c3a">
                    Contact
                  </h2>
                  <p className="leading-relaxed" data-id="element-546" data-mp="3siyky4rp308f">
                    Phone:{' '}
                    <a href="tel:+491745444423" className="text-[#0ea5e9] hover:underline" data-id="element-547" data-mp="1e8bbpdpd2aq">
                      +49 174 5444423
                    </a>
                    <br data-id="element-548" data-mp="34te35p7a290q" />
                    Email:{' '}
                    <a href="mailto:justus@crm-kraft.de" className="text-[#0ea5e9] hover:underline" data-id="element-549" data-mp="39tihb8kpqrns">
                      justus@crm-kraft.de
                    </a>
                  </p>
                </section>

                <section data-id="element-550" data-mp="2m4h3t6x0wqbn">
                  <h2 className="text-2xl font-bold text-white mb-4" data-id="element-551" data-mp="2m3o6ewjyfd66">
                    EU dispute resolution
                  </h2>
                  <p className="leading-relaxed" data-id="element-552" data-mp="sjw051mmwl6a">
                    The European Commission provides an online dispute
                    resolution platform:{' '}
                    <a href="https://ec.europa.eu/consumers/odr/" target="_blank" rel="noopener noreferrer" className="text-[#0ea5e9] hover:underline" data-id="element-553" data-mp="11fdcjtv2yudr">
                      https://ec.europa.eu/consumers/odr/
                    </a>
                    . Our email address can be found above in this imprint.
                  </p>
                </section>

                <section data-id="element-554" data-mp="1gbb93d8x20qi">
                  <h2 className="text-2xl font-bold text-white mb-4" data-id="element-555" data-mp="1gd5rokwptgrf">
                    Consumer dispute resolution
                  </h2>
                  <p className="leading-relaxed" data-id="element-556" data-mp="3m6m7nxhfwr88">
                    We are neither willing nor obliged to participate in dispute
                    resolution proceedings before a consumer arbitration board.
                  </p>
                </section>
              </div>
            </div>
          </div>
        </main>

        <footer className="bg-[#0a0a0a] border-t border-white/5 py-8" data-id="element-557" data-mp="2y9zfjt3xhna9">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-558" data-mp="2y7mydi5zvgy9">
            <p className="text-gray-600 text-sm" data-id="element-559" data-mp="336pw0hjnakw7">
              © {new Date().getFullYear()} Close CRM Agentur. All rights
              reserved.
            </p>
          </div>
        </footer>
      </div>
    </>;
}